import { ChangeEvent } from "react";

import { Client } from "@/Common/Api/Client";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { Geo_Region } from "@/Common/Api/MedfarDictionaries/Dto/Responses/Geo_Region";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { SearchAddress } from "@/Common/Components/Search/SearchAddress";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { LabFacilityModel } from "@/Common/Models/Lab/LabFacilityModel";
import { GeographicInfoTown } from "@/Common/Models/Localization/GeographicInfoTowns";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface IAddEditLabPopup {
    onSaveCallBack: (Lab: LabFacilityModel) => void;
    model?: LabFacilityModel;
    closePopupCallback: () => void;
    parentId?: string;
}

class AddEditLabPopupState {
    public customLab: LabFacilityModel;
    public firstCustomLab: LabFacilityModel;
    public isAddEditSaveButtonDisabled: boolean;
    public availableProvinceLookupIds: Immutable.List<FlatLookupView>;
    public availableCountryLookupIds: FlatLookupView[];
    public availableRegions: Geo_Region[];

    public constructor(init?: Partial<AddEditLabPopupState>) {
        Object.assign(this, init);
    }

    public static getDefault(): AddEditLabPopupState {
        return new AddEditLabPopupState({
            customLab: new LabFacilityModel(null),
            firstCustomLab: new LabFacilityModel(null),
            isAddEditSaveButtonDisabled: false,
            availableRegions: [],
            availableCountryLookupIds: [],
            availableProvinceLookupIds: Immutable.List([])
        });
    }
}

class AddEditLabPopup extends React.Component<IAddEditLabPopup, AddEditLabPopupState> {
    private searchAddressStyle: React.CSSProperties = { width: "330px" };

    public constructor(props: IAddEditLabPopup) {
        super(props);
        let s = AddEditLabPopupState.getDefault();

        if (props.model != null) {
            s.customLab = props.model.Clone();
            s.firstCustomLab = props.model.Clone();
        }

        s.availableCountryLookupIds = cacheStore.GetCountryLookups();

        if (s.customLab.Model.Country.length != 0 || !IsNullOrWhiteSpace(s.customLab.Model.Country))
            s.availableProvinceLookupIds = cacheStore.GetCountryRegionLookups(cacheStore.GetLookupById(s.customLab.countryMyleLookupId)).toImmutable();
        else
            s.availableProvinceLookupIds = cacheStore.GetCountryRegionLookups(cacheStore.GetDefaultCountryForActiveSite()).toImmutable();

        s.availableRegions = cacheStore.RegionsCache;
        s.customLab.countryMyleLookupId = cacheStore.GetDefaultCountryForActiveSite().LookupID;

        this.state = s;
    }

    public componentDidMount(): void {
        window.setTimeout(
            () => {
                $("#" + "edit_modify_lab").focus();
                $("#" + "edit_modify_lab").select();
            },
            200
        );
        sessionStore.showGlobalOverlay(true);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public render(): JSX.Element {
        let initialStreetAddress: string = this.state.customLab.Model.Address;

        let nameIsEmpty = this.state.customLab == null || IsNullOrWhiteSpace(this.state.customLab.Model.Name);

        const lab = (
            <div className="flex-container m ">
                <div className="custom-clinician-labRequest-table" onClick={e => e.stopPropagation()}>

                    <table>
                        <tbody>
                            {(this.state.firstCustomLab.Model.Name) && (
                                <tr>
                                    <td className="col1">
                                        <span className="float-right"> {cacheStore.GetString("NameLabel")}</span>
                                    </td>
                                    <td className="col2">{this.state.firstCustomLab.Model.Name}</td>
                                </tr>
                            )}
                            {(this.state.firstCustomLab.Model.Address) && (
                                <tr>
                                    <td className="col1" style={{ "verticalAlign": "top" }}>
                                        <span className="float-right"> {cacheStore.GetString("AddressLabel")}</span>
                                    </td>
                                    <td className="col2">
                                        <div><p>{this.state.firstCustomLab.Model.Address}  {(this.state.firstCustomLab.Model.Address && this.state.firstCustomLab.Model.RegionNumber) && <span>-Reg</span>}{this.state.firstCustomLab.Model.RegionNumber} </p></div>
                                        <div />
                                        {this.state.firstCustomLab.Model.City}
                                        <div />
                                        {this.state.firstCustomLab.Model.PostalCode}
                                    </td>
                                </tr>
                            )}
                            {(this.state.firstCustomLab.Model.Fax) && (
                                <tr>
                                    <td className="col1">
                                        <span className="float-right"> {cacheStore.GetString("FaxLabel")}</span>
                                    </td>
                                    <td className="col2">{MyleHelper.FormatPhone(this.state.firstCustomLab.Model.Fax, cacheStore.FindLookupByLookupCode(cacheStore.GetCountryLookupById_medfarDictionaries(this.state.customLab.Model.Country)).LookupCode)}</td>
                                </tr>
                            )}
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("NameLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxControl id="edit_modify_lab_name" maxLength={250} valid={!nameIsEmpty} value={!IsNullOrWhiteSpace(this.state.customLab.Model.Name) ? this.state.customLab.Model.Name : ""} onChange={value => this.mutateCustomLabState(l => l.Model.Name = value)} />
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right">{cacheStore.GetString("CountryLabel")}</span>
                                </td>
                                <td className="col2">
                                    <select onChange={e => this.onCountryChange(e)} className="form-control myle-control" value={this.state.customLab.countryMyleLookupId}>
                                        {this.state.availableCountryLookupIds.map((z: FlatLookupView) => (
                                            <option key={z.LookupID} value={z.LookupID}> {cacheStore.GetLocalizedValueByLookupId(z.LookupID)}</option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right">{cacheStore.GetString("StateProvinceLabel")}</span>
                                </td>
                                <td className="col2">
                                    <select onChange={e => this.onProvinceChange(e)} className="form-control myle-control" value={this.state.customLab.provinceMyleLookupId}>
                                        {this.state.availableProvinceLookupIds.toArray().map((z: FlatLookupView) => (
                                            <option key={z.LookupID} value={z.LookupID}> {cacheStore.GetLocalizedValueByLookupId(z.LookupID)}</option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("AddressLabel")}</span>
                                </td>
                                <td className="col2">
                                    <SearchAddress
                                        onItemSelectCallback={({ streetAddress, city, postalCode, stateCode, countryCode }) => {
                                            this.onCivicAddressSelect(streetAddress, city, postalCode, stateCode, countryCode);
                                        }}
                                        streetAddress={initialStreetAddress}
                                        onTextChangeCallback={value => this.mutateCustomLabState(l => l.Model.Address = value)}
                                        debounce={300}
                                        countryCode={cacheStore.GetCountryIsoCodeByLookUpId(this.state.customLab.countryMyleLookupId)}
                                        style={this.searchAddressStyle}
                                        maxLength={300}
                                    />
                                </td>
                            </tr>
                            {(!IsNullOrWhiteSpace(this.state.customLab.Model.Address) && this.state.availableRegions && cacheStore.GetLookupById(this.state.customLab.provinceMyleLookupId).LookupCode === "CanadaState_QC") && (
                                <tr>
                                    <td className="col1">
                                        <span className="float-right">{cacheStore.GetString("RegionLabel")}</span>
                                    </td>
                                    <td className="col2">
                                        <select onChange={e => this.onRegionChange(e)} className="form-control myle-control" value={this.state.customLab.Model.RegionNumber}>
                                            {(IsNullOrWhiteSpace(this.state.customLab.Model.RegionNumber)) && <option value="" />}
                                            {this.state.availableRegions.map((z: Geo_Region) => (
                                                // @ts-ignore: Ignore error
                                                <option key={z.Id} value={parseInt(z.AdministrativeRegionCode)}>{z.Name}</option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            )}
                            {!IsNullOrWhiteSpace(this.state.customLab.Model.Address) && (
                                <tr>
                                    <td className="col1">
                                        <span className="float-right"> {cacheStore.GetString("CityLabel")}</span>
                                    </td>
                                    <td className="col2">
                                        <TextboxControl id="city" maxLength={70} value={this.state.customLab.Model.City} onChange={value => this.mutateCustomLabState(l => l.Model.City = value)} />
                                    </td>
                                </tr>
                            )}
                            {!IsNullOrWhiteSpace(this.state.customLab.Model.Address) && (
                                <tr>
                                    <td className="col1">
                                        <span className="float-right">{cacheStore.GetString("ZipPostalCodeLabel")}</span>
                                    </td>
                                    <td className="col2">
                                        <TextboxMaskedControl
                                            isValid={true}
                                            id={"zipcode" + this.state.customLab.Model.Id}
                                            value={this.state.customLab.Model.PostalCode}
                                            onChangeFunction={value => this.mutateCustomLabState(l => l.Model.PostalCode = value)}
                                            mask={this.state.customLab.GetZipCodeValidationRule().EditMaskPattern}
                                            validationErrorMessage=""
                                        />
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("PhoneNumberLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxMaskedControl
                                        isValid={this.state.customLab.isValidPhone}
                                        allowEmpty={true}
                                        id="phone"
                                        value={this.state.customLab.Model.Phone}
                                        onChangeFunction={(unmasked, masked) => this.mutateCustomLabState(customLab => customLab.SetPhone(unmasked, masked))}
                                        item={null}
                                        mask={this.state.customLab.GetPhoneValidationRule().EditMaskPattern}
                                        validationErrorMessage=""
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("OtherPhoneLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxMaskedControl
                                        isValid={this.state.customLab.isPhonePublicValid}
                                        allowEmpty={true}
                                        id="phonePublic"
                                        value={this.state.customLab.Model.PhonePublic}
                                        onChangeFunction={(unmasked, masked) => this.mutateCustomLabState(customLab => customLab.SetPublicPhone(unmasked, masked))}
                                        item={null}
                                        mask={this.state.customLab.GetPhoneValidationRule().EditMaskPattern}
                                        validationErrorMessage=""
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("FaxLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxMaskedControl
                                        isValid={this.state.customLab.isFaxValid}
                                        allowEmpty={false}
                                        id="fax"
                                        value={this.state.customLab.Model.Fax}
                                        onChangeFunction={(unmasked, masked) => this.mutateCustomLabState(customLab => customLab.SetFax(unmasked, masked))}
                                        item={null}
                                        mask={this.state.customLab.GetPhoneValidationRule().EditMaskPattern}
                                        validationErrorMessage=""
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("PublicFaxLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxMaskedControl
                                        isValid={this.state.customLab.isFaxPublicValid}
                                        allowEmpty={true}
                                        id="faxPublic"
                                        value={this.state.customLab.Model.FaxPublic}
                                        onChangeFunction={(unmasked, masked) => this.mutateCustomLabState(customLab => customLab.SetPublicFax(unmasked, masked))}
                                        item={null}
                                        mask={this.state.customLab.GetPhoneValidationRule().EditMaskPattern}
                                        validationErrorMessage=""
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("EmailLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxMaskedControl
                                        isValid={this.state.customLab.isEmailValid}
                                        alphanumericIncludesPeriod={false}
                                        allowEmpty={true}
                                        id={"Email" + this.state.customLab.Model.Id}
                                        value={!IsNullOrWhiteSpace(this.state.customLab.Model.Email) ? this.state.customLab.Model.Email : ""}
                                        onChangeFunction={value => this.mutateCustomLabState(l => {
                                            l.Model.Email = value;
                                            l.emailValidation(value);
                                        })}
                                        returnMaskedValue={true}
                                        mask={this.state.customLab.GetEmailValidationRule().EditMaskPattern}
                                        isEmail={true}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("ResponsiblePersonLabel")}</span>
                                </td>
                                <td className="col2">
                                    <TextboxControl
                                        id="add_edit_contact_person"
                                        maxLength={200}
                                        value={!IsNullOrWhiteSpace(this.state.customLab.Model.ContactPersonName) ? this.state.customLab.Model.ContactPersonName : ""}
                                        onChange={value => this.mutateCustomLabState(l => l.Model.ContactPersonName = value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="col1">
                                    <span className="float-right"> {cacheStore.GetString("lblDSQPresctionNote")}</span>
                                </td>
                                <td className="col2">
                                    <textarea className="form-control" style={{ "minWidth": "230px", "minHeight": "30px", "resize": "vertical" }} value={!IsNullOrWhiteSpace(this.state.customLab.Model.Note) ? this.state.customLab.Model.Note : ""} id="note_upsertLab" onChange={e => this.onChangeNote(e)} rows={3} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            this.renderModal(lab, nameIsEmpty)
        );
    }

    private renderModal(labRender: JSX.Element, nameIsEmpty: boolean): JSX.Element {
        return (
            <Modal
                title={(this.props.model.Model.Id) ? cacheStore.GetString("EDITLabel") : cacheStore.GetString("AddToDirectoryLabel")}
                width={650}
                onClose={() => this.props.closePopupCallback()}
                footer={this.renderModalFooter(nameIsEmpty)}
                showX
                disableOverlayClose
                fixedOverlayPosition
                centerContent
            >

                <div>
                    <div>{labRender}</div>
                </div>
            </Modal>
        );
    }

    private renderModalFooter(nameIsEmpty: boolean): JSX.Element {
        return (
            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                <ButtonControl className="btn btn-default push-right-5" onClick={() => this.props.closePopupCallback()} label={cacheStore.GetString("CancelLabel")} />
                {(this.props.model.Model.Id) && (
                    <input
                        type="button"
                        className="btn btn-danger push-right-5"
                        value={cacheStore.GetString("DeleteLabel")}
                        onClick={() => sessionStore.showPopup({
                            title: cacheStore.GetString("DeleteLabel"),
                            content: cacheStore.GetString("DeleteMedicalItem3Label"),
                            showCancel: true,
                            okAction: () => this.removeLab()
                        })}
                    />
                )}
                <button className="btn btn-primary" disabled={!this.state.customLab.isFaxValid || nameIsEmpty || IsNullOrWhiteSpace(this.state.customLab.Model.Fax)} onClick={() => this.onSaveEditItem()}>{cacheStore.GetString("SaveLabel")}</button>
            </div>
        );
    }

    private mutateState(mutation: (s: AddEditLabPopupState) => void, then: () => void = null): void {
        let s = new AddEditLabPopupState();
        mutation(s);
        this.setState(s, then);
    }

    private mutateCustomLabState(mutation: (l: LabFacilityModel) => void, then: () => void = null): void {
        let s = new AddEditLabPopupState();
        s.customLab = this.state.customLab.Clone();

        mutation(s.customLab);

        if (then != null)
            this.setState(s, then);
        else
            this.setState(s);
    }

    private async onSaveEditItem(): Promise<void> {
        if (IsNullOrWhiteSpace(this.state.customLab.Model.Name) || IsNullOrWhiteSpace(this.state.customLab.Model.Fax))
            return;

        var response = await Client.postAsync(
            ServerOperations.Server.MedfarDictionnary_UpsertLab,
            { Lab: this.state.customLab.Model }
        );

        if (response.errors.any())
            sessionStore.showPopup(response.errors);
        else {
            this.props.onSaveCallBack(this.state.customLab);
            this.props.closePopupCallback();
        }
    }

    private removeLab(): void {
        let self = this;

        Client.Post(
            ServerOperations.Server.MedfarDictionnary_RemoveLab,
            { Id: this.state.customLab.Model.Id },
            () => {
                self.props.onSaveCallBack(new LabFacilityModel(null));
                self.props.closePopupCallback();
            }
        );
    }

    private onCountryChange(e: ChangeEvent<HTMLSelectElement>): void {
        let countryMyleLookupId = e.target.value;

        this.mutateCustomLabState(lab => {
            lab.SetCountryByMyleLookupId(countryMyleLookupId);
            lab.SetDefaultProvince();
        }, () => this.UpdateRegionList());
    }

    private UpdateRegionList(): void {
        this.mutateState(s => s.availableProvinceLookupIds = Immutable.List(cacheStore.GetCountryRegionLookups(cacheStore.GetLookupById(this.state.customLab.countryMyleLookupId))));
    }

    private onProvinceChange(e: ChangeEvent<HTMLSelectElement>): void {
        let provinceMyleLookupId = e.target.value;
        this.mutateCustomLabState(lab => {
            lab.SetProvinceByMyleLookupId(provinceMyleLookupId);
        });
    }

    private onChangeNote(e: ChangeEvent<HTMLTextAreaElement>): void {
        let val = e.target.value;
        this.mutateCustomLabState(lab => { lab.Model.Note = val; });
    }

    private onCivicAddressSelect(street: string, city: string, postalCode: string, stateCode: string, countryCode: string): void {
        this.mutateCustomLabState(s => {
            if (!IsNullOrWhiteSpace(street))
                s.Model.Address = street;
            if (!IsNullOrWhiteSpace(city))
                s.Model.City = city;
            if (!IsNullOrWhiteSpace(postalCode))
                s.Model.PostalCode = postalCode;
            if (!IsNullOrWhiteSpace(countryCode))
                s.Model.Country = cacheStore.CountryCache.firstOrDefault(p => p.Alpha2Code === countryCode)?.Id;
            if (!IsNullOrWhiteSpace(stateCode)) {
                let resolvedLookup = cacheStore.FindLookupByLookupCode("CanadaState_" + stateCode);
                if (resolvedLookup != null)
                    s.SetProvinceByMyleLookupId(resolvedLookup.LookupID);
            }
            if (!IsNullOrWhiteSpace(city)) {
                let cityClean = SearchMenuHelper.Helper.RemoveDiacritics(city.replace(" ", "").replace("Saint", "St").replace("-", ""));

                let matchCities = cacheStore.TownsCache.filter((x: GeographicInfoTown) => SearchMenuHelper.Helper.RemoveDiacritics(x.Name.replace(" ", "").replace("Saint", "St").replace("-", "")) == cityClean);
                if (matchCities.length > 0)
                    s.Model.RegionNumber = matchCities[0].AdministrativeRegion;
                else
                    s.Model.RegionNumber = "";
            }
        });
    }

    private onRegionChange(e: ChangeEvent<HTMLSelectElement>): void {
        let val = e.target.value;
        this.mutateCustomLabState(lab => { lab.Model.RegionNumber = val; });
    }
}

export { AddEditLabPopup };
